import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { DangerousHTMLDiv, BackButton } from 'ecs-react-components/dist/index.es';
import { logout } from '../../redux/modules/auth/auth-middleware';
import { messages } from './Questionnaires.i18n';
import history from '../../history';

class QuestionnaireScoring extends React.Component {
  handleBackButtonClick = () => {
    history.push(this.props.questionnairesOrigin);
  }

  handleExitButtonClick = () => {
    this.props.dispatch(logout());
  }

  render() {
    let message = '';
    const { assignedQuestionnaires, selectedQuestionnaireId, exitAfterFinalQ } = this.props;
    const questionnaire = assignedQuestionnaires && assignedQuestionnaires.length === 1 ?
      assignedQuestionnaires[0] :
      assignedQuestionnaires.find((q) => q.assignedQuestionnaireId === selectedQuestionnaireId);
    questionnaire.patientScoreList.map((score) => {
      if (score.patientMessageOnCompletion !== '') {
        message += score.patientMessageOnCompletion + ' <br />';
      }
      return score;
    });
    return (
      <div className="questionnaire-scoring-container">
        {
          exitAfterFinalQ && assignedQuestionnaires && assignedQuestionnaires.length < 2 ?
          <BackButton buttonName={messages.scoring.exitButtonText} onClick={this.handleExitButtonClick} /> :
          <BackButton buttonName={messages.scoring.backButtonText} onClick={this.handleBackButtonClick} />
        }
        <h1>{ questionnaire.templateTitle }</h1>
        <div className="spacer tiny"></div>
        <div>
          <DangerousHTMLDiv qaTag="questionnaire-score-summary"
            html={ questionnaire.defaultMsgOnCompletion }
          />
        <br />
        </div>
        <DangerousHTMLDiv
          qaTag="questionnaire-score-summary"
          html={ message }
        />
      </div>
    );
  }
}

QuestionnaireScoring.propTypes = {
  dispatch: PropTypes.func,
  assignedQuestionnaires: PropTypes.array,
  selectedQuestionnaireId: PropTypes.string,
  questionnairesOrigin: PropTypes.string,
  exitAfterFinalQ: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  assignedQuestionnaires: state.questionnaires.assignedQuestionnaires,
  selectedQuestionnaireId: state.questionnaires.selectedQuestionnaireId,
  questionnairesOrigin: state.questionnaires.questionnairesOrigin,
});

export default connect(mapStateToProps)(QuestionnaireScoring);
